/* CANIPANI — Header, menus, panneaux latéraux
   Menu déroulant desktop, menu mobile, panneau de recherche, tiroir panier,
   ombre au défilement, piège de focus et fermeture par Échap. */

(function () {
  'use strict';

  var lastFocused = null;

  /* ---------------------------------------------------- Hauteur du header */

  var headerWrap = document.querySelector('[data-header-wrap]');

  function setHeaderHeight() {
    if (!headerWrap) return;
    document.documentElement.style.setProperty('--header-height', headerWrap.offsetHeight + 'px');
  }

  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight, { passive: true });

  /* ------------------------------------------------- Ombre au défilement */

  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('header--scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------------------------------------------- Panneaux (drawer) */

  var overlay = document.querySelector('[data-overlay]');

  function focusables(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function trapFocus(event, panel) {
    if (event.key !== 'Tab') return;
    var items = focusables(panel);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  var activePanel = null;

  function openPanel(panel) {
    if (!panel) return;
    closePanel();
    lastFocused = document.activeElement;
    activePanel = panel;
    panel.setAttribute('data-open', 'true');
    panel.removeAttribute('aria-hidden');
    panel.removeAttribute('inert');
    if (overlay) overlay.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    var target = panel.querySelector('[data-autofocus]') || focusables(panel)[0];
    if (target) window.setTimeout(function () { target.focus(); }, 60);
    panel.addEventListener('keydown', panelKeydown);
  }

  function panelKeydown(event) {
    if (event.key === 'Escape') { closePanel(); return; }
    if (activePanel) trapFocus(event, activePanel);
  }

  function closePanel() {
    if (!activePanel) return;
    activePanel.setAttribute('data-open', 'false');
    activePanel.setAttribute('aria-hidden', 'true');
    activePanel.setAttribute('inert', '');
    activePanel.removeEventListener('keydown', panelKeydown);
    activePanel = null;
    if (overlay) overlay.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    lastFocused = null;
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-panel-open]');
    if (opener) {
      event.preventDefault();
      openPanel(document.getElementById(opener.getAttribute('data-panel-open')));
      return;
    }
    if (event.target.closest('[data-panel-close]') || event.target.closest('[data-overlay]')) {
      event.preventDefault();
      closePanel();
    }
  });

  document.addEventListener('drawer:open', function (event) {
    openPanel(document.getElementById(event.detail.id));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePanel();
  });

  /* --------------------------------------------- Menu déroulant desktop */

  var navItems = document.querySelectorAll('[data-nav-item]');

  navItems.forEach(function (item) {
    var trigger = item.querySelector('[data-nav-trigger]');
    if (!trigger) return;

    function open() {
      navItems.forEach(function (other) {
        if (other !== item) {
          other.setAttribute('data-open', 'false');
          var t = other.querySelector('[data-nav-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
      item.setAttribute('data-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function close() {
      item.setAttribute('data-open', 'false');
      trigger.setAttribute('aria-expanded', 'false');
    }

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) close();
    });
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      if (item.getAttribute('data-open') === 'true') { close(); } else { open(); }
    });
  });

  /* ------------------------------------------------- Sous-menus mobiles */

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-subnav-toggle]');
    if (!toggle) return;
    event.preventDefault();
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (panel) panel.hidden = expanded;
  });
})();
